/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeFailureStatusRuleDto
 */
export interface ChangeFailureStatusRuleDto {
    /**
     * 
     * @type {string}
     * @memberof ChangeFailureStatusRuleDto
     */
    fromId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeFailureStatusRuleDto
     */
    toId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeFailureStatusRuleDto
     */
    add?: boolean;
}

export function ChangeFailureStatusRuleDtoFromJSON(json: any): ChangeFailureStatusRuleDto {
    return ChangeFailureStatusRuleDtoFromJSONTyped(json, false);
}

export function ChangeFailureStatusRuleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeFailureStatusRuleDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromId': !exists(json, 'fromId') ? undefined : json['fromId'],
        'toId': !exists(json, 'toId') ? undefined : json['toId'],
        'add': !exists(json, 'add') ? undefined : json['add'],
    };
}

export function ChangeFailureStatusRuleDtoToJSON(value?: ChangeFailureStatusRuleDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromId': value.fromId,
        'toId': value.toId,
        'add': value.add,
    };
}


